<div class="qb-receipt">
    <lazy-component
        moduleUri="@lazy-modules-module/receiptHeader/receipt-header.module#ReceiptHeaderModule"
        [inputs]="{ betDate: srmBetReceipt.bet.date }">
    </lazy-component>
    <div class="qb-reuse">
        <span class="qb-reuse-yourbets" [textContent]="YOUR_BETS"></span>
    </div>

    <div class="qb-receipt-wrapper">
        <div class="qb-stake-header">
            <div class="line">
                <div class="left">
                    <div class="qb-stake-info">
                        <strong class="selection-type" [i18n]="'quickbet.sameRaceMulti'" data-crlat="selType"></strong>&nbsp;
                        <strong class="qb-single-receipt-odds" [textContent]="srmOdds" data-uat="odds" data-crlat="odds"></strong>
                        <div class="receipt-id">
                            <span [i18n]="'quickbet.betId'" data-crlat="betId.label"></span>
                            <span [textContent]="srmBetReceipt.receipt" data-uat="betId" data-crlat="betId.value"></span>
                        </div>
                        <div class="srm-sel-info">
                            @for (qa of selectedQuestionAndAnswers; track qa.question) {
                                <p
                                    id="event-name-sel-info"
                                    class="event-name"
                                    [textContent]="qa.answer"
                                    data-uat="eventName"
                                    data-crlat="eventName"></p>
                                <p
                                    id="market-name-sel-info"
                                    class="market-name"
                                    [textContent]="qa.question"
                                    data-uat="marketName"
                                    data-crlat="marketName"></p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="qb-stake-footer">
            <div class="line bs-stake-row summary-info">
                <span class="total-stake" [i18n]="'quickbet.srmTotalStake'" data-crlat="totalStake.label"></span>
                <span class="freebet-stake">
                    <span [textContent]="finalStake" data-crlat="totalStake"></span>
                </span>
            </div>
            <div class="line summary-info">
                <strong [i18n]="'quickbet.estimatedResults'" data-crlat="estimatedResults.label"></strong>
                <span [textContent]="getPotentialPayoutValue(payout)" data-uat="estReturns" data-crlat="estimatedResults.value"></span>
            </div>
        </div>
    </div>
</div>
